<template>
  <div class="col-12 px-0 border-bottom pt-3 mb-4 pb-5">
    <div class="d-flex justify-content-between align-items-center border-bottom border-top py-2">
      <h2 class="mb-0">Show most read (optional)</h2>
      <div>
        <ToggleButton
          type="checkbox"
          v-model="draft.steps.ephemera.showWeekMostRead"
          :color="{ checked: '#0080a8', unchecked: '#c2c7d9' }"
          class="align-self-center"
        />
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center border-bottom border-top py-2">
      <h2 class="mb-0">Show Coronavirus edition latest (optional)</h2>
      <div>
        <ToggleButton
          type="checkbox"
          v-model="draft.steps.ephemera.showLatestCorona"
          :color="{ checked: '#0080a8', unchecked: '#c2c7d9' }"
          class="align-self-center"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  name: 'DailyEquityNoteEphemeraStep',

  components: {
    ToggleButton,
  },

  data () {
    return {
      recommendations: [],
      companies: [],
      results: [],
      resultsSearch: '',
      callsSearch: '',
    }
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
  },

  beforeMount () {
    this.draft.steps.ephemera.showWeekMostRead = typeof this.draft.steps.ephemera.showWeekMostRead === 'undefined' ? true : this.draft.steps.ephemera.showWeekMostRead
    this.draft.steps.ephemera.showLatestCorona = typeof this.draft.steps.ephemera.showLatestCorona === 'undefined' ? true : this.draft.steps.ephemera.showLatestCorona
  },
}
</script>

<style scoped>
h2 {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
}
</style>
